import { keyPathMirror } from 'key-path-mirror';

import { LocalesKey } from '../localesKeysTypes';

interface MenuKeyType {
  contactSupport: LocalesKey;
  hide: LocalesKey;
  keepOpen: LocalesKey;
  links: {
    all: LocalesKey;
    access: LocalesKey;
    acceptanceDocuments: LocalesKey;
    accounts: LocalesKey;
    accountingTransactions: LocalesKey;
    active: LocalesKey;
    allInvoices: LocalesKey;
    bills: LocalesKey;
    blocked: LocalesKey;
    chatGPTPrompts: LocalesKey;
    clients: LocalesKey;
    emailTemplates: LocalesKey;
    favorite: LocalesKey;
    finance: LocalesKey;
    generalLedger: LocalesKey;
    invoices: LocalesKey;
    itemTags: LocalesKey;
    roles: LocalesKey;
    pages: LocalesKey;
    permissions: LocalesKey;
    people: LocalesKey;
    sections: LocalesKey;
    products: LocalesKey;
    projects: LocalesKey;
    tasks: LocalesKey;
    transactionsImports: LocalesKey;
    smartContractExpenseImports: LocalesKey;
    invoiceProcessingJobs: LocalesKey;
    content: LocalesKey;
    reports: LocalesKey;
    reportSections: LocalesKey;
    archiAppSections: LocalesKey;
    sentMessages: LocalesKey;
    smartContracts: LocalesKey;
    stock: LocalesKey;
    messages: LocalesKey;
    my: LocalesKey;
    companies: LocalesKey;
    defaultItemTypes: LocalesKey;
    itemTypes: LocalesKey;
    itemCategories: LocalesKey;
    avBillingInfos: LocalesKey;
    depositInvoices: LocalesKey;
    workers: LocalesKey;
    smartContractFees: LocalesKey;
    unassigned: LocalesKey;
    archeidos: LocalesKey;
    twinAssets: LocalesKey;
    twins: LocalesKey;
  };
  tabs: {
    knowledgeLibrary: LocalesKey;
    bookstack: LocalesKey;
    dashboard: LocalesKey;
    notifications: LocalesKey;
    tasksAndProjects: LocalesKey;
    workspace: LocalesKey;
    workspaceBeta: LocalesKey;
    stock3d: LocalesKey;
    users: LocalesKey;
    workers: LocalesKey;
    people: LocalesKey;
    clients: LocalesKey;
    admin: LocalesKey;
    payments: LocalesKey;
    library: LocalesKey;
    myLibrary: LocalesKey;
    reports: LocalesKey;
    tools: LocalesKey;
    aiStudio: LocalesKey;
  };
}

export const menuKeys = keyPathMirror<MenuKeyType, string>(
  {
    contactSupport: null,
    hide: null,
    keepOpen: null,
    links: {
      all: null,
      access: null,
      acceptanceDocuments: null,
      accounts: null,
      accountingTransactions: null,
      active: null,
      allInvoices: null,
      bills: null,
      blocked: null,
      chatGPTPrompts: null,
      clients: null,
      emailTemplates: null,
      favorite: null,
      finance: null,
      generalLedger: null,
      invoices: null,
      itemTags: null,
      roles: null,
      pages: null,
      permissions: null,
      people: null,
      sections: null,
      products: null,
      projects: null,
      tasks: null,
      transactionsImports: null,
      smartContractExpenseImports: null,
      invoiceProcessingJobs: null,
      content: null,
      reports: null,
      reportSections: null,
      archiAppSections: null,
      sentMessages: null,
      smartContracts: null,
      stock: null,
      messages: null,
      my: null,
      companies: null,
      defaultItemTypes: null,
      itemTypes: null,
      itemCategories: null,
      avBillingInfos: null,
      depositInvoices: null,
      workers: null,
      smartContractFees: null,
      unassigned: null,
      archeidos: null,
      twinAssets: null,
      twins: null
    },
    tabs: {
      knowledgeLibrary: null,
      bookstack: null,
      dashboard: null,
      notifications: null,
      tasksAndProjects: null,
      workspace: null,
      workspaceBeta: null,
      stock3d: null,
      users: null,
      workers: null,
      people: null,
      clients: null,
      admin: null,
      payments: null,
      library: null,
      myLibrary: null,
      reports: null,
      tools: null,
      aiStudio: null
    }
  },
  'models.menu.'
);
